import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useCreateClassificationMutation } from '../../../generated/graphql';
import { FormField } from '../../form';
import styles from './NewClassificationDialog.module.css';

type NewClassificationDialogProps = {
    onClose: () => void,
    typeId: string,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const NewClassificationDialog = (props: NewClassificationDialogProps) => {
    const { style, visible, typeId, onClose } = props;
    const [createType, createTypeResult] = useCreateClassificationMutation();
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [validationError, setValidationError] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const nameError = submitted && !name.trim() ? 'Name is required.' : '';
    const descriptionError = submitted && !description.trim() ? 'Description is required.' : '';

    const handleSubmit = () => {
        setSubmitted(true);
        if (!name.trim() || !description.trim()) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        setValidationError('');
        createType({
            variables: {
                classification: { name: name.trim(), typeId, description: description.trim() }
            }
        })
            .then(() => onClose())
            .catch(() => {});
    };

    return (
        <DialogBase
            isLoading={createTypeResult.loading}
            title="New Entity"
            type='OkCancel'
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            visible={visible}
            className={styles.NewClassificationDialog}
            style={style}
            data-testid="NewClassificationDialog">
            <FormField label="Name" name="name" value={name} onChange={setName} required error={nameError} />
            <FormField label="Description" name="description" value={description} onChange={setDescription} required error={descriptionError} />
        </DialogBase>
    );
};

export default NewClassificationDialog;